import { computed, inject, onMounted, ref, type SetupContext } from "vue";
import { useI18n } from "vue-i18n";
import { appConfigProviderKey } from "../../../infrastructure/app_config_provider";
import { currentOrderProviderKey } from "../../../infrastructure/current_order_provider";
import { orderApiKey } from "../../../infrastructure/gfo_api/order_api";
import html_iway from "./template.iway.html?raw";
import {
  whoamiApiKey,
  type WhoamiDto,
} from "../../../infrastructure/gfo_api/whoami_api";
import type {
  OrderCreateRequest,
  OrderResetRequest,
} from "../../../infrastructure/gfo_api/order_api";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

export default {
  template: html,
  components: {},
  emits: {
    checkerCompleted: () => true,
  },
  setup(_props: any, { emit }: SetupContext) {
    const { t } = useI18n();
    const appConfig = inject(appConfigProviderKey);
    const currentOrderProvider = inject(currentOrderProviderKey);
    const orderApi = inject(orderApiKey);
    const whoamiApi = inject(whoamiApiKey);
    const whoamiDto = ref<WhoamiDto | null>(null);

    const checkerKey = computed(() => {
      const businessType =
        currentOrderProvider?.currentOrder?.value?.business_type;
      if ("business" == businessType) {
        return appConfig?.checker_key_business;
      } else {
        return appConfig?.checker_key_private;
      }
    });

    const currentUrl = computed(function () {
      return window.location.href;
    });

    const checkerTheme = computed(() => "light");
    onMounted(async () => {
      const res = await whoamiApi?.getWhoami();
      if (typeof res !== "undefined") {
        whoamiDto.value = res;
      }
    });

    const handleCheckerResponse = async (evt: any) => {
      const currentOrder = currentOrderProvider?.currentOrder?.value;
      if (!orderApi) {
        return;
      }
      if (!currentOrder) {
        console.log(evt);
        const request: OrderCreateRequest = {
          netz: evt.detail?.netz,
          order_for: appConfig?.order_for ?? "new",
          partner_number: appConfig?.partner_number ?? null,
          username: null, // TODO
          customer_number: null, //TODO
          pv_ids: [],
          checker_result_uid: evt.detail?.checker_result_uid,
        };
        const newOrder = await orderApi.create(request);
        currentOrderProvider?.set(newOrder);
        if (newOrder) {
          const variants = await orderApi.getAvailableVariants(
            newOrder?.order_reference,
          );
          currentOrderProvider?.setVariants(variants);
        }
      } else {
        const request: OrderResetRequest = {
          netz: evt.detail?.netz,
          order_for: appConfig?.order_for ?? currentOrder?.order_for ?? "new",
          partner_number: appConfig?.partner_number ?? null,
          username: null, // TODO
          customer_number: null, //TODO
          pv_ids: [],
          checker_result_uid: evt.detail?.checker_result_uid,
        };
        const newOrder = await orderApi?.reset(
          currentOrder.order_reference,
          request,
        );
        currentOrderProvider.set(newOrder);
        if (newOrder) {
          const variants = await orderApi.getAvailableVariants(
            newOrder?.order_reference,
          );
          currentOrderProvider?.setVariants(variants);
        }
      }
      emit("checkerCompleted");
    };

    return {
      t,
      appConfig,
      checkerKey,
      checkerTheme,
      handleCheckerResponse,
      whoamiDto,
      currentUrl,
    };
  },
};
